"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Button = {
    baseStyle: {
        fontWeight: 'normal',
        maxWidth: '100%',
        textDecoration: 'none',
    },
    defaultProps: {
        variant: 'outline',
    },
    sizes: {
        sm: {
            fontSize: '13px',
            height: '30px',
            py: '5px',
            px: '10px',
        },
    },
    variants: {
        outline: {
            borderColor: 'inherit',
            bgColor: 'white',
            color: 'blueGray.900',
        },
        // Custom Chakra variants require explicitly defined states (at least for now).
        cta: {
            bgColor: 'blue.500',
            color: 'white',
            _hover: {
                bgColor: 'blue.600',
                textDecoration: 'none',
                _disabled: {
                    bgColor: 'blue.500',
                    color: 'white',
                },
            },
            _active: {
                bgColor: 'blue.700',
            },
            focusVisible: {
                boxShadow: 'outline',
            },
        },
    },
};
exports.default = Button;
